import React, { Component } from 'react'
import configs from '../../../configs.json'

class MVV extends Component {
    constructor(props) {
        super(props)
        this.state = {
            colored   : this.props.colored,
            dark      : this.props.dark
        }
    }
    colorize() {
        if (this.state.colored && this.state.dark) {
            this.setState({backgroundColor : configs.colors.primary})
            this.setState({text            : configs.colors.light})
            this.setState({color           : configs.colors.dark})
        }
        if (!this.state.colored && !this.state.dark) {
            this.setState({color           : configs.colors.primary})
            this.setState({text            : configs.colors.dark})
            this.setState({backgroundColor : configs.colors.light})
        }
        if (!this.state.colored && this.state.dark) {
            this.setState({color           : configs.colors.primary})
            this.setState({text            : configs.colors.light})
            this.setState({backgroundColor : configs.colors.dark})
        }
        if (this.state.colored && !this.state.dark) {
            this.setState({backgroundColor : configs.colors.primary})
            this.setState({text            : configs.colors.dark})
            this.setState({color           : configs.colors.light})
        }
    }
    componentDidMount() {
        this.colorize()
    }
    render(){
        return (
            <div className='container' style={{backgroundColor: this.state.backgroundColor }} id='mvv'>
                <div className='row section-row'>
                    <h3 style={{color: this.state.color}}>MVV</h3>
                    <h6 style={{color: this.state.text}}>Nos conheça melhor</h6>
                    <br></br>
                    <div className='col s12 m4'>
                        <div className='card-panel mvv-card' style={{backgroundColor: configs.colors.offwhite}}>
                            <h5 style={{color:configs.colors.secondary}}>Missão</h5>
                            <p>{configs.mvv.mission}</p>
                        </div>
                    </div>
                    <div className='col s12 m4'>
                        <div className='card-panel mvv-card' style={{backgroundColor: configs.colors.offwhite}}>
                            <h5 style={{color:configs.colors.secondary}}>Visão</h5>
                            <p>{configs.mvv.vision}</p>
                        </div>
                    </div>
                    <div className='col s12 m4'>
                        <div className='card-panel mvv-card' style={{backgroundColor: configs.colors.offwhite}}>
                            <h5 style={{color:configs.colors.secondary}}>Valores</h5>
                            <p>{configs.mvv.values}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MVV